// src/pages/MarketplacePage.js

import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeftIcon,
  ShoppingBagIcon,
} from "@heroicons/react/24/outline";

import "../components/Walletview.css";

const MarketplacePage = () => {
  const navigate = useNavigate();

  const goBack = () => navigate("/dashboard");

  // ==========================================================
  // STYLES
  // ==========================================================
  const styles = {
    page: {
      width: "100%",
      minHeight: "80vh",
      background: "#faf8f5",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      overflowX: "hidden",
    },

    container: {
      width: "calc(100% - 40px)",
      maxWidth: 540,
      margin: "0 auto 32px",
      padding: "0 0 16px",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "50vh",
    },

    pageTitle: {
      width: "100%",
      marginBottom: 24,
      boxSizing: "border-box",
    },
    titleWrapper: {
      position: "relative",
      width: "100%",
      minHeight: 52,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box",
    },
    backButton: {
      position: "absolute",
      left: 0,
      top: "50%",
      transform: "translateY(-50%)",
      width: 36,
      height: 36,
      padding: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "rgba(154,106,24,0.06)",
      border: "1px solid rgba(154,106,24,0.12)",
      borderRadius: "10px",
      color: "#9a6a18",
      cursor: "pointer",
      transition: "all 0.2s ease",
      boxSizing: "border-box",
      flexShrink: 0,
    },
    titleContent: {
      width: "100%",
      textAlign: "center",
      padding: "0 48px",
      boxSizing: "border-box",
    },
        title: {
      margin: "0 0 5px",

      fontFamily:
        "'Inter', 'Poppins', 'Segoe UI', sans-serif",

      fontSize: 26,

      lineHeight: 1.1,

      fontWeight: 600,

      letterSpacing: "1.4px",

      color: "#8a5a1f",

      WebkitTextStroke: "0.4px #6b3d0a",

      textShadow:
        "0 1px 0 rgba(255, 240, 200, 0.6), 0 2px 6px rgba(154, 106, 24, 0.22)",
    },
    subtitle: {
      margin: "4px 0 0",

      fontFamily:
        "'Poppins', 'Segoe UI', sans-serif",

      fontSize: 11,

      fontWeight: 500,

      letterSpacing: "0.6px",

      lineHeight: 1.3,

      color: "#a07a3f",

      opacity: 0.95,
    },

    comingSoonCard: {
      background: "#ffffff",
      borderRadius: "16px",
      padding: "48px 32px",
      border: "1px solid #ece4d6",
      boxShadow: "0 4px 16px rgba(0,0,0,0.03)",
      textAlign: "center",
      maxWidth: "400px",
      width: "100%",
    },
    comingSoonIcon: {
      color: "#9a6a18",
      marginBottom: "16px",
    },
    comingSoonTitle: {
      fontSize: "28px",
      fontWeight: 700,
      color: "#2a1f12",
      marginBottom: "8px",
    },
    comingSoonText: {
      fontSize: "16px",
      color: "#8a7a62",
      lineHeight: 1.6,
    },
  };

  // ==========================================================
  // RENDER
  // ==========================================================
  return (
    <div style={styles.page}>
      {/* Main content */}
      <div style={styles.container}>
        <div style={styles.pageTitle}>
          <div style={styles.titleWrapper}>
            {/* BACK BUTTON — uses shared .market-back-btn styles */}
        <button
          type="button"
          className="market-back-btn"
          onClick={goBack}
          title="Back to Dashboard"
          aria-label="Back to Dashboard"
        >
          <ArrowLeftIcon width={18} height={18} />
        </button>
            <div style={styles.titleContent}>
              <h1 style={styles.title}>Marketplace</h1>
              <p style={styles.subtitle}>
                Discover and buy unique items with BAIT
              </p>
            </div>
          </div>
        </div>

        <div style={styles.comingSoonCard}>
          <div style={styles.comingSoonIcon}>
            <ShoppingBagIcon width={64} height={64} />
          </div>
          <h2 style={styles.comingSoonTitle}>Coming Soon</h2>
          <p style={styles.comingSoonText}>
            The BAIT Marketplace is under development.
            <br />
            Soon you'll be able to buy and sell unique items,
            <br />
            and more using BAITCash.
          </p>
          <div style={{ marginTop: "16px" }}>
            <span
              style={{
                fontSize: "14px",
                color: "#9a6a18",
                fontWeight: 500,
              }}
            >
              🚀 Stay tuned for updates
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketplacePage;